import React from 'react';
import { CTAButton } from './CTAButton';
import { PRODUCT_IMAGE } from '../data/hero';
export function FinalCTA() {
  return <section aria-label="Ottieni il sistema" className="bg-obsidian text-white" data-id="element-71" data-mp="3udoz2oyozioy">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 py-16 text-center lg:grid-cols-2 lg:py-24 lg:text-left" style={{
      paddingTop: "23px",
      paddingBottom: "33px"
    }} data-id="element-72" data-mp="c7tw1mrnowv3">
        <div data-id="element-73" data-mp="m4f0o6zrk5ye">
          <h2 className="font-display text-4xl font-extrabold uppercase leading-[0.92] sm:text-6xl" data-id="element-74" data-mp="m3wx0parupgg">
            Allenati con metodo.
            <br data-id="element-75" data-mp="h5lpil7y8r1e" />
            Gestisci meglio le energie.
            <br data-id="element-76" data-mp="vv1crr89uecc" />
            <span className="text-electric" data-id="element-77" data-mp="vtgj03ts6zfj">Affronta la gara con più sicurezza.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-md text-lg text-white/70 lg:mx-0" data-id="element-78" data-mp="qwzsx430uazt">
            Un unico sistema per organizzare il percorso dalla preparazione al traguardo.
          </p>
          <div className="mt-8 flex justify-center lg:justify-start" data-id="element-79" data-mp="zx4s4qy2a32w">
            <CTAButton href="#pricing" data-id="element-80" data-mp="2c4wmkk3t04fa">Ottieni il sistema completo</CTAButton>
          </div>
          <p className="mt-3 text-xs text-white/50" data-id="element-81" data-mp="2h3rh2jb4vhf8">27 € · Pagamento unico · Garanzia di 7 giorni</p>
        </div>
        <img src={PRODUCT_IMAGE} alt="IL SISTEMA TRIATHLON FULL DISTANCE™ con i quattro strumenti pratici" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto h-auto w-full max-w-[560px]" data-id="element-82" data-mp="2m2b3ektn2v84" />
      </div>
    </section>;
}